/**
 * LandingLayout component - Layout wrapper for landing pages
 */

import {ReactNode} from 'react';
import {Navbar} from '../landing/Navbar';
import {Footer} from '../landing/Footer';

interface LandingLayoutProps {
  children: ReactNode;
}

export function LandingLayout({children}: LandingLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

